// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3Prt3","rootCenter":"LoadMoreObserver_rootCenter__hIUlI","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2haY6"};